<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="login-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h5 class="h5 mb-4">Please Complete Your Biometrics</h5>
      <BiometricsForm :user="user" :signup="true"/>
    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BiometricsForm from '../../components/Biometrics/BiometricsForm'

export default {
  name: 'Biometrics',
  components: { BiometricsForm },
  data() {
    return {
      user: {}
    }
  },
  computed: {
    ...mapGetters(['getMyInfo'])
  },
  methods: {
    ...mapActions(['getMe'])
  },
  mounted: async function() {
    await this.getMe()
    this.user = this.getMyInfo
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/Biometrics.vue?58357e13